import React, { useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox, Button
} from "@mui/material";

const Settings = ({ onPrevious,
  smsStatus,
  whatsappStatus,
  mailStatus,
  handleSmsCheckboxChange,
  handleWhatsappCheckboxChange,
  handleMailCheckboxChange,
}) => {
  const renderSmsCheckbox = (field) => (
    <Checkbox
      checked={smsStatus[field]}
      onChange={() => handleSmsCheckboxChange(field)}
      color="success"
    />
  );

  const renderWhatsappCheckbox = (field) => (
    <Checkbox
      checked={whatsappStatus[field]}
      onChange={() => handleWhatsappCheckboxChange(field)}
      color="success"
    />
  );

  const renderMailCheckbox = (field) => (
    <Checkbox
      checked={mailStatus[field]}
      onChange={() => handleMailCheckboxChange(field)}
      color="success"
    />
  );

  return (
    <>
      <Grid item xs={12} sm={12} md={6}>
        <TableContainer
          sx={{
            border: "1px solid #cbcbcb",
          }}
        >
          <Table sx={{ borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                ></TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  Loan Open
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  Loan Close
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  Over Due
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  General Reminder
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  SMS alert to customers
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderSmsCheckbox("smsloanOpen")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderSmsCheckbox("smsloanClose")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderSmsCheckbox("smsoverDue")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderSmsCheckbox("smsgeneralReminder")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  WhatsApp alert to customers
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderWhatsappCheckbox("whatsapploanOpen")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderWhatsappCheckbox("whatsapploanClose")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderWhatsappCheckbox("whatsappoverDue")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderWhatsappCheckbox("whatsappgeneralReminder")}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  Email alert to customers
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderMailCheckbox("mailloanOpen")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderMailCheckbox("mailloanClose")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderMailCheckbox("mailoverDue")}
                </TableCell>
                <TableCell
                  sx={{ border: "1px solid #cbcbcb", textAlign: "center" }}
                >
                  {renderMailCheckbox("mailgeneralReminder")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
          <Grid item>
            <Button
              variant="outlined"
              style={{ marginTop: "8px" }} onClick={onPrevious}>
              Previous
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </>
  );
};

export default Settings;
